<template>
  <div id="webterminal" style="width: 100%; height: 600px"></div>
</template>
<script>
export default {
  methods: {
    loadJS(url, implementationCode, location) {
      try {
        var scriptTag = document.createElement("script");
        scriptTag.src = url;

        scriptTag.onload = implementationCode;
        scriptTag.onreadystatechange = implementationCode;
        location.appendChild(scriptTag);
      } catch (err) {
        console.log("EE", err);
      }
    },
    onScriptLoaded() {
      try {
        new MetaTraderWebTerminal( "webterminal", {
          version: (this.$route.query.platform == 'MT4') ? 4 : 5,
          servers: (this.$route.query.platform == 'MT4') ? ["FXView-Demo", "FXView-Live"] : ["FXView-Demo", "FXView-Live"],
          server: (this.$route.query.platform == 'MT4') ? "FXView-Demo" : "FXView-Demo",
          utmSource: "fxview.uk",
          startMode: "create_demo",
          language: "en",
          colorScheme: "black_on_white"
        });
        this.$router.replace({query: null})
      } catch (err) {
        console.log("EE", err);
      }
    },
  },
  created() {
    this.loadJS(
      /*"https://trade.mql5.com/trade/widget.js",*/
      "https://metatraderweb.app/trade/widget.js",
      this.onScriptLoaded,
      document.body
    );
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/web_trade_link_new.vue